import React from 'react'
import {  Box, Button, Grid, TextField, Select, MenuItem,
  FormControl, InputLabel, InputAdornment, IconButton, Typography } from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import HeaderBox from '../../../components/HeaderBox';
import DateCalander from '../../../components/DateCalander';

const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

function AddVehicle() {
  const navigate = useNavigate()
  return (
    <Box mt={2}>
      <Grid container spacing={1}>
        <Grid item xs={12} >
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>VEHICLE UPDATE</Typography>
                </Grid>
                <Grid item xs={6} display='flex' justifyContent='flex-end' >
                    <Button sx={buttonStyle.root} onClick={() => navigate('/Add_Vechicle')}>Save</Button>&nbsp;
                    <Button sx={buttonStyle.root} onClick={() => navigate('/Master')}>Cancel</Button>
                </Grid>
            </Grid>
        </Grid>
          
        <Grid item xs={12} mt={1}>
          <Box>
          <form>
          <Grid container spacing={1}>
              <Grid item xs={12} >
                <HeaderBox title='Vehicle Details'/>
              </Grid>
              <Grid item xs={12}>
              <Box sx={boxStyle.root} >
                <Grid container spacing={1}>
                <Grid item xs={2}>
                  <TextField fullWidth size='small' label= 'VRM id' variant="outlined"required name=' VRM id' disabled/>
                    </Grid>
                    <Grid item xs={2} >
                    <TextField fullWidth size='small' label="VRM" variant="outlined" required name='VRM'/>
                    </Grid>
                  <Grid item xs={2}>
                    <TextField fullWidth size='small' label="Make" variant="outlined" required name='Make'/>
                  </Grid>
                  <Grid item xs={2}>
                    <TextField fullWidth size='small' label="Model" variant="outlined" required name='Model'/>
                  </Grid>
                    <Grid item xs={1} >
                     <DateCalander  title='Mrf Date'/>
                    </Grid>
                    <Grid item xs={1} >
                    <TextField fullWidth size='small' label="MOT" variant="outlined" required name='MOT'/>
                  </Grid>
                  <Grid item xs={1} >
                    <TextField fullWidth size='small' label="MOT Due" variant="outlined" required name='MOT Due'/>
                  </Grid>
                  <Grid item xs={1} >
                    <TextField fullWidth size='small' label="Fleet No" variant="outlined" required name='Fleet No'/>
                  </Grid>
                  <Grid item xs={2}>
                    <TextField fullWidth size='small' label="Engine Number" variant="outlined" required name='Engine Number'/>
                  </Grid>
                  <Grid item xs={2}>
                    <TextField fullWidth size='small' label="Gear Type" variant="outlined" required name='Gear Type'/>
                  </Grid>
                  <Grid item xs={2} >
                    <TextField fullWidth size='small' label="Color" variant="outlined" required name='Color'/>
                  </Grid>
                  <Grid item xs={2} >
                    <TextField fullWidth size='small' label="First Used" variant="outlined" required name='First Used'/>
                  </Grid>
                  <Grid item xs={2} >
                    <TextField fullWidth size='small' label="Last Service" variant="outlined" required name='Last Service'/>
                  </Grid>
                  <Grid item xs={2} >
                    <TextField fullWidth size='small' label="Service Due" variant="outlined" required name='Service Due'/>
                  </Grid>
                  <Grid item xs={12} >
                    <HeaderBox title='Owner Details'/>
                  </Grid>
                  <Grid item xs={1} >
                    <TextField fullWidth size='small' label="Owner Code" variant="outlined" required name='Owner Code'/>
                  </Grid>
                  <Grid item xs={2} >
                    <TextField fullWidth size='small' label="First Owner Name" variant="outlined" required name='First Owner Name'/>
                  </Grid>
                  <Grid item xs={4} >
                    <TextField fullWidth size='small' label="First Owner Address" variant="outlined" required name='First Owner Address'/>
                  </Grid>
                  <Grid item xs={2.5} >
                    <TextField fullWidth size='small' label="Email ID" variant="outlined" required name='Email ID'/>
                  </Grid>
                  <Grid item xs={2.5} >
                    <TextField fullWidth size='small' label="Mobile No" variant="outlined" required name='Mobile No'/>
                  </Grid>
                  <Grid item xs={3} >
                    <TextField fullWidth size='small' label="New Owner Name" variant="outlined" required name='New Owner Name'/>
                  </Grid>
                  <Grid item xs={3} >
                    <TextField fullWidth size='small' label="New Owner Address" variant="outlined" required name='New Owner Address'/>
                  </Grid>
                  <Grid item xs={3} >
                    <TextField fullWidth size='small' label="Email ID" variant="outlined" required name='Email ID'/>
                  </Grid>
                  <Grid item xs={3} >
                    <TextField fullWidth size='small' label="Mobile No" variant="outlined" required name='Mobile No'/>
                  </Grid>
                  <Grid item xs={12} >
                    <TextField fullWidth size='large' label="Remark" variant="outlined" required name='Remark' />
                  </Grid>
                </Grid>
              </Box>
              </Grid>
              </Grid> 
          </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
    )
}
export default AddVehicle